export const REQUEST_CHECKLIST = 'zola/checklist/REQUEST_CHECKLIST';
export const UPDATE_CHECKLIST = 'zola/checklist/UPDATE_CHECKLIST';
export const RECEIVE_CHECKLIST = 'zola/checklist/RECEIVE_CHECKLIST';
export const RECEIVE_CHECKLIST_V2 = 'zola/checklist/RECEIVE_CHECKLIST_V2';
export const ADD_TASK = 'zola/checklist/ADD_TASK';
export const UPDATE_TASK = 'zola/checklist/UPDATE_TASK';
export const REMOVE_TASK = 'zola/checklist/REMOVE_TASK';
export const RECEIVE_TASK = 'zola/checklist/RECEIVE_TASK';
export const REQUEST_TEMPLATES = 'zola/checklist/REQUEST_TEMPLATES';
export const RECEIVE_TEMPLATES = 'zola/checklist/RECEIVE_TEMPLATES';
export const SELECT_TASK = 'zola/checklist/SELECT_TASK';
export const UNSELECT_TASK = 'zola/checklist/UNSELECT_TASK';
export const TOGGLE_COMPLETED = 'zola/checklist/TOGGLE_COMPLETED';
export const INC_ONBOARD_STEP = 'zola/checklist/INC_ONBOARD_STEP';
export const DEC_ONBOARD_STEP = 'zola/checklist/DEC_ONBOARD_STEP';
export const TOGGLE_ONBOARD = 'zola/checklist/TOGGLE_ONBOARD';
export const REQUEST_STATS = 'zola/checklist/REQUEST_STATS';
export const RECEIVE_STATS = 'zola/checklist/RECEIVE_STATS';
export const RESET_CHECKLIST = 'zola/checklist/RESET_CHECKLIST';
export const REQUEST_TRADITIONS = 'zola/checklist/REQUEST_TRADITIONS';
export const RECEIVE_TRADITIONS = 'zola/checklist/RECEIVE_TRADITIONS';
export const TOGGLE_TEMPLATES = 'zola/checklist/TOGGLE_TEMPLATES';
export const TOGGLE_CHECKLIST_FILTER = 'zola/checklist/TOGGLE_CHECKLIST_FILTER';
export const REPLACE_CHECKLIST_FILTERS = 'zola/checklist/REPLACE_CHECKLIST_FILTER';
export const CLEAR_CHECKLIST_FILTER = 'zola/checklist/CLEAR_CHECKLIST_FILTER';
export const RECEIVE_CHECKLIST_FILTERED = 'zola/checklist/RECEIVE_CHECKLIST_FILTERED';
export const RECEIVE_CHECKLIST_FILTERED_GROUPS = 'zola/checklist/RECEIVE_CHECKLIST_FILTERED_GROUPS';
export const TOGGLE_INVITE_PARTNER_VIEW = 'zola/checklist/TOGGLE_INVITE_PARTNER_VIEW';



// WEBPACK FOOTER //
// ./src/actions/types/ChecklistActionTypes.js